import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Label, TextInput, Button } from 'flowbite-react';
import { HiMail, HiLockClosed } from 'react-icons/hi';
import { observer } from 'mobx-react-lite';
import { authStore } from '../stores/authStore';
import { toastStore } from '../stores/toastStore';

const LoginPage: React.FC = observer(() => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // If already authenticated, redirect to dashboard
    if (authStore.isAuthenticated) {
      navigate('/dashboard');
    }
  }, [authStore.isAuthenticated, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    const success = await authStore.login(email, password);

    if (success) {
      navigate('/dashboard');
    } else if (authStore.error) {
      toastStore.showError(authStore.error);
    }

    setIsLoading(false);
  };

  return (
    <Card>
      <form onSubmit={handleSubmit} className="space-y-4">
        <h2 className="text-2xl font-bold text-gray-900">ログイン</h2>
        

        <div>
          <Label htmlFor="email" value="メールアドレス" />
          <TextInput
            id="email"
            type="email"
            icon={HiMail}
            placeholder="email@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isLoading}
          />
        </div>

        <div>
          <Label htmlFor="password" value="パスワード" />
          <TextInput
            id="password"
            type="password"
            icon={HiLockClosed}
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={isLoading}
          />
        </div>

        <div className="text-right">
          <button
            type="button"
            onClick={() => navigate('/forgot-password')}
            className="text-sm text-blue-600 hover:underline"
            disabled={isLoading}
          >
            パスワードを忘れた場合
          </button>
        </div>

        <Button
          type="submit"
          className="w-full"
          disabled={isLoading}
          isProcessing={isLoading}
        >
          ログイン
        </Button>
      </form>
    </Card>
  );
});

export default LoginPage;